import classNames from 'classnames';

import { Slot, useSlots } from '@xemplo/slot';

import { ModalBody } from './body';
import { ModalCloseButton } from './close-button';
import { ModalFooter } from './footer';
import { ModalHeader } from './header';
import * as S from './modal-dialog.styles';
import { ModalDialogSlot, ModalProps } from './modal-dialog.types';

export const ModalTestId = {
  container: 'modal-container',
};

export function Modal({ children, className }: ModalProps) {
  const slots = useSlots({ children });
  return (
    <S.ModalContainer
      data-testid={ModalTestId.container}
      className={classNames('modal-container', className)}
    >
      {slots[ModalDialogSlot.CloseButton]}
      {slots[ModalDialogSlot.Header]}
      {slots[ModalDialogSlot.Body]}
      {slots[ModalDialogSlot.Footer]}
    </S.ModalContainer>
  );
}
Modal.Slot = Slot;
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.CloseButton = ModalCloseButton;
Modal.Dialog = S.ModalDialogBase;
